// models
import type {
  ReqChangeNationMobile,
  ReqResetPassword,
  ReqSendSms,
  ReqTempPassword,
  ReqVerifyCode
} from '../models/sms.model';

/**
 * SMS 관련 Query Keys
 *
 * @description
 * SMS 인증번호 발송, 검증 및 비밀번호 관련 query-key들을 관리합니다.
 */
export const smsKeys = {
  /** ALL */
  SMS_ALL: ['sms'],

  /** 인증번호 발송 */
  SEND_SMS: (params: ReqSendSms) => ['sms', 'sendSms', JSON.stringify(params)],

  /** 인증번호 단순 검증 */
  VERIFY_CODE: (params: ReqVerifyCode) => ['sms', 'verifyCode', JSON.stringify(params)],

  /** 인증번호 검증 및 패스워드 재설정 */
  VERIFY_CODE_FOR_PWD: (params: ReqResetPassword) => [
    'sms',
    'verifyCodeForPwd',
    JSON.stringify(params)
  ],

  /** 임시 비밀번호 생성 및 발송 */
  SEND_TEMP_PWD: (params: ReqTempPassword) => ['sms', 'sendTempPwd', JSON.stringify(params)],

  /** 회원 가입 또는 모바일+국가 변경을 위한 인증코드 발송 */
  SEND_SMS_FOR_CHANGE_NATION_MOBILE: (params: ReqChangeNationMobile) => [
    'sms',
    'sendSmsForChangeNationMobile',
    JSON.stringify(params)
  ]
};
